import { render } from "./FirebaseAuth.vue?vue&type=template&id=57ece47a&scoped=true&ts=true"
import script from "./FirebaseAuth.vue?vue&type=script&lang=ts"
export * from "./FirebaseAuth.vue?vue&type=script&lang=ts"

import "./FirebaseAuth.vue?vue&type=style&index=0&id=57ece47a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57ece47a"]])

export default __exports__